import type { ProductListAPIResponse } from '@partful/shared-types';
import { Job } from '@providers/job/types';

export const getFilteredConfigurationsAndJobs = (
  configurations: ProductListAPIResponse,
  jobs: Job[],
  searchFieldState: string
) => {
  if (!searchFieldState.length || searchFieldState.length < 3) {
    return { filteredConfigurations: configurations, filteredJobs: jobs };
  }

  const filteredConfigurations = configurations.filter((configuration) =>
    configuration.name.toLowerCase().includes(searchFieldState.toLowerCase())
  );

  const filteredJobs = jobs.filter((job) => job.productName?.toLowerCase().includes(searchFieldState.toLowerCase()));

  return { filteredConfigurations, filteredJobs };
};
